import React, { useState, useEffect } from "react";
import {
    Container,
    Row,
    Col,
    Card,
    CardBody,
    Button,
    Input,
    Form,
    FormGroup,
    Label,
    UncontrolledTooltip
} from "reactstrap";
import { useFormik } from "formik";
import * as Yup from "yup";
//import { Card, CardBody, Form, FormGroup, Label, Input, Button, Container, Col, Row } from "reactstrap";
import { Link } from "react-router-dom";
import Breadcrumbs from "components/Common/Breadcrumb";
import TableContainer from "components/Common/TableContainer";
import getAccessRights from "components/Common/getAccessRights";
import { useLocation, useHistory } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { useAuthUserDetails } from "components/Common/getAuthUserDetails";
import { changeTaxStatus, fetchTax, saveTax } from "store/actions";
import Swal from "sweetalert2";
import Loader from "common/pageLoader";

const monthType = [
    { label: "Yearly", value: "1" },
    { label: "Quarterly", value: "2" },
    { label: "Half Yearly", value: "3" },
    { label: "Monthly", value: "4" },
];

const DeductionTax = () => {
    const dispatch = useDispatch();
    const [authDetails, setAuthDetails] = useState(null);
    const {
        tax,
        loading,
        success,
        error,
    } = useSelector((state) => ({
        tax: state.PayrollDeductionTaxReducer?.tax ?? [],

        loading: state.PayrollDeductionTaxReducer?.loading,
        error: state.PayrollDeductionTaxReducer?.error,
        success: state.PayrollDeductionTaxReducer?.success,
    }));

    const [isEdit, setIsEdit] = useState(false);
    const [editId, setEditId] = useState(null);

    const location = useLocation();
    const history = useHistory();

    useEffect(() => {
        const accessRight = getAccessRights(location.pathname, history);
    }, [location]);

    useEffect(() => {
        const authUserDetails = useAuthUserDetails();
        setAuthDetails(authUserDetails[0])
        const unitId = authUserDetails[0].unit_id
        dispatch(fetchTax(unitId));
    }, [dispatch]);

    useEffect(() => {
        if (success) {
            dispatch(fetchTax(authDetails?.unit_id));
            formik.resetForm({
                values: {
                    rangeFrom: "",
                    rangeTo: "",
                    amount: ""
                }
            });

            setIsEdit(false);
            setEditId(null);
        }
    }, [authDetails, success, dispatch]);

    const formik = useFormik({
        initialValues: {
            rangeFrom: "",
            rangeTo: "",
            amount: "",
            monthType: "",
        },
        validationSchema: Yup.object({
            rangeFrom: Yup.number()
                .typeError("Range from must be a number")
                .required("Range from is required")
                .min(0, "Must be 0 or greater")
                .integer("Only whole numbers allowed")
                .max(9999999999, "Max length is 10 digits"),

            rangeTo: Yup.number()
                .typeError("Range to must be a number")
                .required("Range to is required")
                .moreThan(Yup.ref("rangeFrom"), "Must be greater than From")
                .integer("Only whole numbers allowed")
                .max(9999999999, "Max length is 10 digits"),

            amount: Yup.number()
                .typeError("Amount must be a number")
                .required("Amount is required")
                .min(0, "Amount must be positive")
                .integer("Only whole numbers allowed")
                .max(9999999999, "Max length is 10 digits"),
            monthType: Yup.string().required("Month type is required"),
        }),
        onSubmit: (values) => {
            const formData = new FormData();
            formData.append("ptax_id", editId ? editId : 0);
            formData.append("start_amount", values.rangeFrom);
            formData.append("end_amount", values.rangeTo);
            formData.append("tax_amount", values.amount);
            formData.append("unit_id", authDetails?.unit_id);
            formData.append("create_by", authDetails?.user_id);
            formData.append("month_type", values.monthType);
            dispatch(saveTax(formData))
        },
    });

    const handleEdit = (row) => {
        formik.setValues({
            rangeFrom: row.start_amount,
            rangeTo: row.end_amount,
            amount: row.tax_amount,
            monthType: row.month_type,
            unitid: authDetails?.unit_id,
            createdby: authDetails?.user_id,
        });
        setIsEdit(true);
        setEditId(row.ptax_id);
    };

    const columns = [
        { Header: "S#", Cell: ({ row }) => tax.length - row.index, className: "serial-no text-center", },
        { Header: "SLAB_FROM", accessor: "start_amount" },
        { Header: "SLAB_TO", accessor: "end_amount" },
        { Header: "AMOUNT", accessor: "tax_amount" },
        { Header: "MONTH_TYPE", accessor: "month_type_name" },
        { Header: "CREATED_BY", accessor: "create_by" },
        { Header: "CREATED_DATE", accessor: "create_dt" },
        {
            Header: "ACTIONS",
            className: "text-center",
            Cell: (cellProps) => {
                //const { status, id} = cellProps.row.original;
                //const isActive = status === 1; // Status 1 = Active
                const { ptax_id } = cellProps.row.original;
                return (
                    <div className="text-center">
                        <Link
                            to="#"
                            className="text-success"
                            onClick={() => handleEdit(cellProps.row.original)}
                        >
                            <i className="bx bxs-edit font-size-18" id="edittooltip" />
                            <UncontrolledTooltip placement="top" target="edittooltip">
                                Edit
                            </UncontrolledTooltip>
                        </Link>
                    </div>
                );
            },
        },
    ];

    const handleCancel = () => {
        formik.resetForm();
        setIsEdit(false);
        setEditId(null);
    };

    return (
        <React.Fragment>
            <div className="page-content">
                <Loader loading={loading} />
                <Container fluid>
                    <Breadcrumbs title="Payroll / Deduction" breadcrumbItem="Tax" />
                    <Card >
                        <CardBody>
                            <Form onSubmit={formik.handleSubmit}>
                                <Row className="mb-3 g-3 align-items-center">
                                    <Col md={2}>
                                        <FormGroup>
                                            <Label for="rangeFrom">Range From <span className="text-danger">*</span></Label>
                                            <Input
                                                type="text"
                                                id="rangeFrom"
                                                name="rangeFrom"
                                                inputMode="numeric"
                                                value={formik.values.rangeFrom}
                                                onChange={(e) => {
                                                    const value = e.target.value.replace(/[^0-9]/g, "");
                                                    formik.setFieldValue("rangeFrom", value);
                                                }}
                                                onBlur={formik.handleBlur}
                                            />
                                            {formik.touched.rangeFrom && formik.errors.rangeFrom ? (
                                                <p className="text-danger ">{formik.errors.rangeFrom}</p>
                                            ) : null}
                                        </FormGroup>
                                    </Col>

                                    <Col md={2}>
                                        <FormGroup>
                                            <Label for="rangeTo">Range To <span className="text-danger">*</span></Label>
                                            <Input
                                                type="text"
                                                id="rangeTo"
                                                name="rangeTo"
                                                inputMode="numeric"
                                                value={formik.values.rangeTo}
                                                onChange={(e) => {
                                                    const value = e.target.value.replace(/[^0-9]/g, "");
                                                    formik.setFieldValue("rangeTo", value);
                                                }}
                                                onBlur={formik.handleBlur}
                                            />
                                            {formik.touched.rangeTo && formik.errors.rangeTo ? (
                                                <p className="text-danger ">{formik.errors.rangeTo}</p>
                                            ) : null}
                                        </FormGroup>
                                    </Col>

                                    <Col md={2}>
                                        <FormGroup>
                                            <Label for="amount">Amount <span className="text-danger">*</span></Label>
                                            <Input
                                                type="text"
                                                id="amount"
                                                name="amount"
                                                inputMode="numeric"
                                                value={formik.values.amount}
                                                onChange={(e) => {
                                                    const value = e.target.value.replace(/[^0-9]/g, "");
                                                    formik.setFieldValue("amount", value);
                                                }}
                                                onBlur={formik.handleBlur}
                                            />
                                            {formik.touched.amount && formik.errors.amount ? (
                                                <p className="text-danger ">{formik.errors.amount}</p>
                                            ) : null}
                                        </FormGroup>
                                    </Col>
                                    <Col md={3}>
                                        <FormGroup>
                                            <Label>Month Type <span className="text-danger">*</span></Label>
                                            <Input
                                                type="select"
                                                name="monthType"
                                                value={formik.values.monthType}
                                                onChange={formik.handleChange}
                                                onBlur={formik.handleBlur}
                                                className={formik.touched.monthType && formik.errors.monthType ? "is-invalid" : ""}
                                            >
                                                <option value="">Select</option>
                                                {monthType.map((item) => (
                                                    <option key={item.value} value={item.value}>
                                                        {item.label}
                                                    </option>
                                                ))}
                                            </Input>

                                            {formik.touched.monthType && formik.errors.monthType && (
                                                <div className="text-danger">{formik.errors.monthType}</div>
                                            )}
                                        </FormGroup>
                                    </Col>

                                    <Col md="3" className="d-flex justify-content-end mt-3 text-end">
                                        <Button type="submit" className="btn button-save me-2">
                                            <i className="fas fa-save me-1" /> {isEdit ? "Update" : "Save"}
                                        </Button>
                                        <Button type="button"
                                            onClick={() => {
                                                Swal.fire({
                                                    title: "Are you sure?", text: "Unsaved clear will be lost!", icon: "warning",
                                                    showCancelButton: true, confirmButtonText: "Yes, Clear", cancelButtonText: "No", confirmButtonColor: "#3085d6", cancelButtonColor: "#d33"
                                                }).then((result) => { if (result.isConfirmed) { handleCancel(); } });
                                            }}
                                            className="btn button-cancel" >
                                            <i className="fas fa-sync me-1" /> Cancel
                                        </Button>
                                    </Col>
                                </Row>


                            </Form>
                        </CardBody>
                    </Card>
                    <Card>
                        <CardBody>
                            <div className="modal-body p-1">
                                <div className="row">
                                    <TableContainer
                                        columns={columns}
                                        data={tax && tax?.length > 0 ? tax : []}
                                        isGlobalFilter={true}
                                        customPageSize={10}
                                    />
                                </div>
                            </div>
                        </CardBody>
                    </Card>
                </Container>
            </div>
        </React.Fragment>
    );
};

export default DeductionTax;
